import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { FilterResponseItem } from '../../interfaces/types'

const initialState: FilterResponseItem[] = (window as any).filterSectionModel.filters;

const filtersSlice = createSlice({
    name: 'filters-slice',
    initialState,
    reducers: {
        setFilters: (state, action: PayloadAction<FilterResponseItem[]>) => {
            return action.payload
        }
    },
})

export const { setFilters } = filtersSlice.actions;
export default filtersSlice.reducer;